import { ProfilePage as ProfileComponent } from '../components/profile/ProfilePage';

export default function ProfilePage({ role }) {
  const userId = localStorage.getItem('userId') || undefined;
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-semibold">My Profile</h1>
          <p className="text-muted-foreground mt-1">
            Manage your profile settings and preferences
          </p>
        </div>
      </div>
      <ProfileComponent role={role} userId={userId} />
    </div>
  );
}
